import { render, staticRenderFns } from "./HistoryFooter.vue?vue&type=template&id=3c603916&"
import script from "./HistoryFooter.vue?vue&type=script&lang=js&"
export * from "./HistoryFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports